
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: boolean;
  onClick?: () => void;
}

export default function Card({
  children,
  className = '',
  padding = 'md',
  shadow = true,
  onClick
}: CardProps) {
  const baseClasses = 'bg-white rounded-2xl border border-gray-100';
  const shadowClass = shadow ? 'shadow-lg shadow-gray-200/50' : '';
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  const hoverClass = onClick ? 'hover:shadow-xl hover:scale-[1.02] transition-all duration-200 cursor-pointer' : '';
  
  return (
    <div
      className={`${baseClasses} ${shadowClass} ${paddingClasses[padding]} ${hoverClass} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
